<template>
  <div>
    <div
      :class="{
        'mobile-share-page': isH5,
        'pc-share-page': !isH5,
        'electron-share-page': isElectron,
      }"
      class="share-page"
    >
      <p v-if="!isH5" class="page-title">
        <span>拼团-{{ productInfo.course_name }}</span>
      </p>
      <div class="page-cont-wrap">
        <!-- 页面上方 -->
        <div class="page-top-wrap">
          <!-- 拼团失败 -->
          <div v-if="groupInfo.state === 3 || groupEnd" class="group-info-fail">
            该拼团已过期，可发起新拼团
          </div>
          <!-- 已成团不可超员参团 -->
          <div
            v-else-if="groupInfo.state === 2 && !canExceed"
            class="group-info-fail"
          >
            该拼团已拼成，可发起新拼团
          </div>
          <!-- 团购信息 -->
          <GroupInfo
            v-else
            :courseInfo="productInfo"
            :activeInfo="groupInfo"
            :canExceed="canExceed"
          />
          <!-- 课程卡片 -->
          <CourseCard :courseInfo="productInfo" :activeInfo="groupInfo" />
        </div>
        <div class="course-detail-wrap">
          <!-- tab -->
          <div class="tab-box">
            <div
              :class="{
                'tabs-fixed': detailNavFixed,
                'electron-tab-fixed': isElectron,
              }"
              :style="'top:' + tabFixTop + 'px'"
            >
              <ul class="tabs-wrap">
                <li
                  v-for="item in tabList"
                  :key="item.id"
                  :class="{ active: item.id === activeId }"
                  @click="changeTab(item)"
                >
                  {{ item.title }}
                </li>
              </ul>
            </div>
          </div>

          <!-- 详情 -->
          <div class="tab-content ql-snow" ref="detail">
            <CourseDescription
              :isH5="isH5"
              :courseDescription="productInfo.course_description || ''"
            />
          </div>
          <!-- 机构信息 -->
          <OrgCard
            class="group-org-card"
            :orgInfo="orgInfo"
            :isH5="isH5"
            :orgId="productInfo.org_id || ''"
          />
          <!-- 课程 -->
          <div class="tab-content course-cont" ref="course">
            <LessonList
              :isRegistered="productInfo.enrollment !== null"
              :unitList="productInfo.unit_list || []"
            />
          </div>
        </div>

        <!-- 温馨提示 -->
        <TipsText :orgInfo="orgInfo" />

        <!-- 底部按钮 -->
        <!-- 未登录||未参与该拼团 -->
        <div v-if="!isAuthenticated || !isJoined">
          <!-- 待成团或已成团可超员参加 -->
          <div
            v-if="
              groupInfo.state === 1 ||
              (groupInfo.state === 2 && canExceed && !groupEnd)
            "
            class="fixed-bottom"
          >
            <button class="text-btn" @click="signUp(0)">发起拼团</button>
            <button
              class="primary-btn join-group"
              @click="signUp(groupInfo.group_id)"
            >
              <span class="price"
                ><i>￥</i>{{ groupInfo.group_price / 100 }}</span
              ><span class="text">加入此团</span>
            </button>
          </div>
          <!-- 已成团不可超员参加或已过期 -->
          <div v-else class="fixed-bottom">
            <button @click="goProductDetail" class="text-btn">查看课程</button>
            <button @click="signUp(0)" class="primary-btn create-group-btn">
              发起拼团
            </button>
          </div>
        </div>
        <!-- 登录账号+已参与该拼团 -->
        <div v-else-if="isAuthenticated && isJoined">
          <!-- 待成团 -->
          <div v-if="groupInfo.state === 1" class="fixed-bottom">
            <button @click="goGroupInfo" class="text-btn">
              您已参团 <br v-if="isH5" />
              还差
              <span class="activity-color">{{ groupInfo.diffNum }}</span> 人成团
            </button>
            <button @click="copyShareUrl" class="primary-btn share-group-btn">
              分享拼团
            </button>
          </div>
          <!-- 已成团 -->
          <div v-else-if="groupInfo.state === 2" class="fixed-bottom">
            <button @click="goGroupInfo" class="text-btn">
              您已成团<br v-if="isH5" />
              拼团详情
            </button>
            <button @click="goLearningCenter" class="primary-btn go-study-btn">
              开始学习
            </button>
          </div>
          <div v-else class="fixed-bottom">
            <button @click="goGroupInfo" class="text-btn">拼团详情</button>
            <button @click="signUp(0)" class="primary-btn create-group-btn">
              发起拼团
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="confirm-order-container"></div>
  </div>
</template>

<script>
import share from "./share.js";
export default {
  mixins: [share],
};
</script>

<style lang="scss" scoped>
.pc-share-page {
  --group-share-primary: #{$saas-text-color};
  --group-share-secondary: #515350;
  --group-share-page-bg: #{$saas-bg-color};
  --group-share-card-bg: #ffffff;
  --group-share-fail-bg: url("../../../assets/images/group-activity/fail-group-info-bg.png");
  --group-share-fixed-shadow: 0px 6px 16px 0px rgba(102, 116, 107, 0.1);

  html.dark & {
    --group-share-primary: var(--mg-text-primary);
    --group-share-secondary: var(--mg-text-secondary);
    --group-share-page-bg: var(--mg-bg-page);
    --group-share-card-bg: var(--mg-bg-card);
    --group-share-fail-bg: var(--mg-bg-card);
    --group-share-fixed-shadow: none;
  }

  padding-bottom: 150px;
  // 解决scrollview被吸顶部分遮盖问题
  .tab-box {
    height: 55px;
  }
  .ql-snow,
  .course-cont {
    padding-top: 68px;
    margin-top: -68px;
    background: transparent !important;
  }
  .group-org-card {
    padding-bottom: 12px;
  }
  .page-title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    // position: fixed;
    // top: 0;
    background: var(--group-share-card-bg);
    height: 70px;
    // z-index: 9;
    span {
      max-width: 800px;
      font-weight: 600;
      font-size: 16px;
      color: var(--group-share-primary);
      line-height: 22px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
    }
  }
  .group-info-fail {
    display: flex;
    align-items: center;
    width: 800px;
    height: 100px;
    background: var(--group-share-fail-bg);
    background-size: 100% auto;
    padding-left: 48px;
    font-weight: 500;
    font-size: 30px;
    color: var(--group-share-primary, #{$saas-text-color});
    line-height: 42px;
    margin-top: 30px;
    border-radius: 24px;
  }
  .page-cont-wrap {
    max-width: 800px;
    background: var(--group-share-page-bg);
    margin: 0 auto;
  }
  .page-top-wrap {
    // 标题高度
    padding-top: 1px;
    padding-bottom: 24px;
  }
  .course-detail-wrap {
    background: var(--group-share-card-bg);
    border-radius: 24px;
    padding: 0 16px 20px;
    // tab
    .tabs-wrap {
      display: flex;
      align-items: center;
      padding: 16px 0 10px 16px;
      li {
        font-weight: 400;
        font-size: 16px;
        color: var(--group-share-secondary);
        line-height: 22px;
        padding-bottom: 7px;
        margin-right: 40px;
        cursor: pointer;
      }
      .active {
        position: relative;
        font-weight: 600;
        color: var(--group-share-primary);
        &::after {
          position: absolute;
          content: " ";
          display: block;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 16px;
          height: 3px;
          background: linear-gradient(
            132deg,
            $linear-gradient-begin 0%,
            $linear-gradient-end 100%
          );
          border-radius: 2px;
        }
      }
    }
    .tabs-fixed {
      position: fixed;
      width: 100vw;
      z-index: 2;
      background: var(--group-share-card-bg);
      box-shadow: var(--group-share-fixed-shadow);
      left: 0;
      top: 0;
      .tabs-wrap {
        width: 100%;
        padding: 23px 28px 12px;
        max-width: 800px;
        margin: 0 auto;
      }
      li {
        padding-bottom: 11px;
      }
    }
  }
  // 底部按钮
  .fixed-bottom {
    position: fixed;
    bottom: 0;
    width: 800px;
    height: 100px;
    background: var(--group-share-card-bg);
    box-shadow: var(--group-share-fixed-shadow);
    border-radius: 24px 24px 0px 0px;
    padding: 0 34px 0 34px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  // .joined-state1,
  // .joined-state2 {
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  // }
  .text-btn {
    font-weight: 500;
    font-size: 16px;
    color: var(--group-share-primary);
    line-height: 22px;
    padding-right: 23px;
    position: relative;
    &::after {
      position: absolute;
      content: " ";
      right: 0;
      top: 50%;
      display: block;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      background: url("../../../assets/images/product-details/text-btn-arrow.png");
      background-size: 100% 100%;
    }
  }
  .primary-btn {
    width: 150px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 16px;
    color: #ffffff;
    line-height: 22px;
    background: url("../../../assets/images/group-activity/create-group-btn.png");
    background-size: 100% 100%;
  }
  .share-group-btn {
    position: relative;
    top: -6px;
    width: 160px;
    height: 64px;
    background: url("../../../assets/images/group-activity/share-group-btn.png");
    background-size: 100% 100%;
    padding: 14px 10px 0 0;
  }
  .go-study-btn {
    background: url("../../../assets/images/group-activity/go-study-btn.png");
    background-size: 100% 100%;
  }
  .join-group {
    justify-content: space-between;
    width: 195px;
    height: 50px;
    background: url("../../../assets/images/group-activity/join-group-btn.png");
    background-size: 100% 100%;
    .price {
      width: 95px;
      text-align: center;
      color: #f03349;
      i {
        font-style: normal;
        font-size: 10px;
      }
    }
    .text {
      width: 90px;
      text-align: center;
    }
  }
}
.mobile-share-page {
  --group-share-primary: #{$saas-text-color};
  --group-share-secondary: #515350;
  --group-share-page-bg: #ffffff;
  --group-share-card-bg: #ffffff;
  --group-share-fail-bg: url("../../../assets/images/group-activity/fail-group-info-bg.png");
  --group-share-fixed-shadow: 0rem 0.08rem 0.21rem 0rem rgba(102, 116, 107, 0.1);

  html.dark & {
    --group-share-primary: var(--mg-text-primary);
    --group-share-secondary: var(--mg-text-secondary);
    --group-share-page-bg: var(--mg-bg-page);
    --group-share-card-bg: var(--mg-bg-card);
    --group-share-fail-bg: var(--mg-bg-card);
    --group-share-fixed-shadow: none;
  }

  background: var(--group-share-page-bg);
  font-size: 0.37rem;
  padding-bottom: 2.1rem;
  // .page-title {
  //   display: flex;
  //   align-items: center;
  //   justify-content: center;
  //   width: 100%;
  //   position: fixed;
  //   top: 0;
  //   background: #ffffff;
  //   height: 1.04rem;
  //   box-shadow: 0rem 0.05rem 0.08rem 0rem rgba(0, 0, 0, 0.07);
  //   border: 0.03rem solid #ffffff;
  //   padding: 0 0.53rem;
  //   span {
  //     max-width: 100%;
  //     font-weight: 600;
  //     font-size: 0.4rem;
  //     color: $saas-text-color;
  //     line-height: 0.56rem;
  //     white-space: nowrap;
  //     overflow: hidden;
  //     text-overflow: ellipsis;
  //     word-break: break-all;
  //   }
  // }
  .page-top-wrap {
    // 标题高度
    padding-top: 1px;
    padding-bottom: 0.32rem;
  }
  .group-info-fail {
    display: flex;
    align-items: center;
    width: 9.36rem;
    height: 1.33rem;
    background: var(--group-share-fail-bg);
    background-size: 100% auto;
    padding-left: 0.64rem;
    font-weight: 500;
    font-size: 0.4rem;
    color: var(--group-share-primary, #{$saas-text-color});
    line-height: 0.56rem;
    margin: 0.32rem auto 0;
    border-radius: 0.32rem;
  }
  .course-detail-wrap {
    background: var(--group-share-card-bg);
    padding-bottom: 0.27rem;
    // tab
    .tabs-wrap {
      display: flex;
      align-items: center;
      padding: 0 0 0.1rem 0.45rem;
      li {
        font-weight: 400;
        font-size: 0.37rem;
        color: var(--group-share-secondary);
        line-height: 0.53rem;
        padding-bottom: 0.08rem;
        margin-right: 0.59rem;
        cursor: pointer;
      }
      .active {
        position: relative;
        font-weight: 600;
        color: var(--group-share-primary);
        &::after {
          position: absolute;
          content: " ";
          display: block;
          left: 50%;
          bottom: 0;
          transform: translateX(-50%);
          width: 0.21rem;
          height: 0.05rem;
          border-radius: 0.03rem;
          background: linear-gradient(
            132deg,
            $linear-gradient-begin 0%,
            $linear-gradient-end 100%
          );
        }
      }
    }
    .tabs-fixed {
      position: fixed;
      width: 100%;
      z-index: 2;
      background: var(--group-share-card-bg);
      box-shadow: var(--group-share-fixed-shadow);
      left: 0;
      top: 0;
      .tabs-wrap {
        width: 100%;
        padding: 0.32rem 0 0.27rem 0.45rem;
        max-width: 100%;
        margin: 0 auto;
      }
    }
    // .ql-snow {
    //   padding-top: 1.2rem;
    //   margin-top: -1.2rem;
    //   background: transparent !important;
    // }
    // .course-cont {
    //   padding-top: 1.73rem;
    //   margin-top: -1.73rem;
    //   background: transparent !important;
    // }
  }
  // 底部按钮
  .fixed-bottom {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 1.97rem;
    background: var(--group-share-card-bg);
    box-shadow: var(--group-share-fixed-shadow);
    border-radius: 0.64rem 0.64rem 0rem 0rem;
    padding: 0 0.53rem 0 0.32rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  // .joined-state1,
  // .joined-state2 {
  //   display: flex;
  //   align-items: center;
  //   justify-content: space-between;
  // }
  .text-btn {
    text-align: left;
    font-weight: 500;
    font-size: 0.43rem;
    color: var(--group-share-primary);
    line-height: 0.6rem;
    position: relative;
    padding-right: 0.56rem;
    &::after {
      position: absolute;
      content: " ";
      right: 0;
      bottom: 0.03rem;
      display: block;
      width: 0.43rem;
      height: 0.43rem;
      background: url("../../../assets/images/product-details/text-btn-arrow.png");
      background-size: 100% 100%;
    }
  }
  .primary-btn {
    width: 4.19rem;
    height: 1.33rem;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 0.43rem;
    color: #ffffff;
    line-height: 0.6rem;
    background: url("../../../assets/images/group-activity/create-group-btn.png");
    background-size: 100% 100%;
  }
  .share-group-btn {
    position: relative;
    top: -0.09rem;
    left: 0.13rem;
    width: 4.78rem;
    height: 1.71rem;
    background: url("../../../assets/images/group-activity/share-group-btn.png");
    background-size: 100% 100%;
    padding: 14px 10px 0 0;
  }
  .go-study-btn {
    background: url("../../../assets/images/group-activity/go-study-btn.png");
    background-size: 100% 100%;
  }
  .join-group {
    justify-content: space-between;
    width: 5.2rem;
    height: 1.33rem;
    background: url("../../../assets/images/group-activity/join-group-btn.png");
    background-size: 100% 100%;
    .price {
      width: 2.36rem;
      text-align: center;
      color: #f03349;
      i {
        font-style: normal;
        font-size: 0.27rem;
      }
    }
    .text {
      width: 2.37rem;
      text-align: center;
    }
  }
}
.activity-color {
  color: #f03349 !important;
}

//electron
.pc-share-page.electron-share-page {
  .ql-snow,
  .course-cont {
    padding-top: calc(68px + #{$nav-height});
    margin-top: -128px;
    background: transparent !important;
  }
}
.electron-tab-fixed.tabs-fixed {
  width: calc(100% - #{$side-bar-width}) !important;
  left: $side-bar-width !important;
}
</style>
